import { ManageLocalStorage } from '../utils/manageLocalStorage';
import { $Q } from '../utils/querySelector';
import Swiper, { Navigation, Autoplay } from 'swiper';
import 'swiper/css';

const manageLocalStorage = new ManageLocalStorage();

/**
 * Class to tobar
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */
class TopBar {
  /**
   * Receives id's elements and assign elements
   * @param {string} idComponent - id of the component parent
   * @param {string} idClose - id of the btn close compoginent
   */
  constructor(idComponent, idClose) {
    this.elTopBar = $Q(idComponent);
    this.headerElement = $Q('#header') && $Q('#header');

    if (this.elTopBar) {
      this._init();
    }
  }

  /**
   * Init tob bar features
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _init() {
    this._sliderTopBar();
  }

  /**
   * Method to build top bar slider
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _sliderTopBar() {
    if (!this.elTopBar.classList.contains('hidden')) {
      this.slide = new Swiper('.slider__top-bar', {
        modules: [Navigation, Autoplay],
        slidesPerView: 1,
        spaceBetween: 25,
        navigation: {
          nextEl: `.swiper-button-next[data-id="slider__top-bar"]`,
          prevEl: `.swiper-button-prev[data-id="slider__top-bar"]`,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    }
  }

  /**
   * Calculate header height when change with tobBard
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _calculateHeaderHeight() {
    $Q('#js-menu-component').style.top = `${this.headerElement.offsetHeight}px`;

    if ($Q('.js-hero-home-parent .hero-home__container')) {
      $Q(
        '.js-hero-home-parent .hero-home__container'
      ).style.paddingTop = `${this.headerElement.offsetHeight}px`;
    }
  }
}

export { TopBar };
